import {
	EventDispatcher,
	Matrix4,
	Plane,
	Raycaster,
	Vector2,
	Vector3,
    Quaternion
} from 'three';

import * as marietta from '../../..';
import { ThreeView } from '../View3dWebCad';
import {RayIntersection} from '../Octree/RayIntersection';
import { webcadDefines } from '..';

const _raycaster = new Raycaster();

const _pointer = new Vector2();
const _worldPosition = new Vector3();
const _inverseMatrix = new Matrix4();
const _pointStart = new Vector3();
const _positionStart = new Vector3();

const _rayWall = new Raycaster();

class CeilingItemOverControls extends EventDispatcher {

	constructor( _objects, _camera, _domElement ) {

		super();

		_domElement.style.touchAction = 'none'; // disable touch scroll

		let _selected = null, _hovered = null;

		const _intersections = [];
		const _intersectionsWall = [];

		//
		const scope = this;

		function activate() {

			_domElement.addEventListener( 'pointermove', onPointerMove );

		}

		function deactivate() {

			_domElement.removeEventListener( 'pointermove', onPointerMove );

			_domElement.style.cursor = '';

		}

		function dispose() {

			deactivate();

		}

		function getObjects() {

			return _objects;

		}

		function getRaycaster() {

			return _raycaster;

		}

		function onPointerMove( event ) {

			if ( scope.enabled === false ) return;

			updatePointer( event );

			_raycaster.setFromCamera( _pointer, _camera );

			// hover support
			if ( event.pointerType === 'mouse' || event.pointerType === 'pen' ) {
				// 天井アイテム
				_rayWall.setFromCamera(_pointer, ThreeView.get().wcCameras.camera.me);
				const intersections = new RayIntersection(_rayWall);
				const intersectObjects = intersections.getTargets_(ThreeView.get().CameraTarget.box3Status);

				if (intersectObjects.length > 0) {
					for (let i = 0; i < intersectObjects.length; i ++) {
						if (intersectObjects[i].object && intersectObjects[i].object.userData.type && (intersectObjects[i].object.userData.type == webcadDefines.ExtrasType.CEILING) && (intersectObjects[i].object.userData.sub_type == webcadDefines.ExtrasSubType.CEILING)) {
							const pos = intersectObjects[i].point;
							_objects[0].position.copy(pos);

							break;
						}

						if (_objects[0].uuid == getTarget(intersectObjects[i].object)?.uuid) {
							continue;
						} else {
							_objects[0].position.copy(_positionStart);
							_objects[0].position.applyMatrix4( _inverseMatrix );
							break;
						}
					}

					scope.dispatchEvent( { type: 'hoveron', object: object } );

					_domElement.style.cursor = 'pointer';
					_hovered = object;
				}
			}

		}

        function object( object ) {
            ;
        }

            // 対象オブジェクトを取得
        function getTarget( object ) {
			if (object == null) return;
            const index = _objects.findIndex((obj) => obj.uuid == object.uuid);
            if (index <= -1)  return getTarget(object.parent);
            return _objects[index];
        }

		function updatePointer( event ) {

			const rect = _domElement.getBoundingClientRect();

			_pointer.x = ( event.clientX - rect.left ) / rect.width * 2 - 1;
			_pointer.y = - ( event.clientY - rect.top ) / rect.height * 2 + 1;

		}

		activate();

		// API

		this.enabled = true;
		this.transformGroup = false;

		this.activate = activate;
		this.deactivate = deactivate;
		this.dispose = dispose;
		this.getObjects = getObjects;
		this.getRaycaster = getRaycaster;

	}

}

export { CeilingItemOverControls };
